export default (function (value) {
  return value === undefined;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isUndefined.js
// module id = 1855
// module chunks = 0